module.exports = __webpack_public_path__ + "img/hcdl_main0.3a7377c6.jpg";